import { render, staticRenderFns } from "./EventAdmin.vue?vue&type=template&id=1dba0f83&"
import script from "./EventAdmin.vue?vue&type=script&lang=js&"
export * from "./EventAdmin.vue?vue&type=script&lang=js&"
import style0 from "./EventAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports